import React from "react";

const defaultValue = {
  basepath: undefined,
  changeBasePath: () => {},
};

export const BaseContext = React.createContext(defaultValue);
